<template>
    <div id="app">
       <!-- <section class="hero is-info">
            <div class="hero-body">
            <p class="title has-text-centered">
                STATISTIK GERAKAN PANDAI
            </p>
            </div>
      </section>  -->
       <b-button  class="button is-primary"
            tag="router-link"
            to="/admin/berandareport"
            icon-left="arrow-left-bold">Kembali</b-button>
      <div class="box">
      <div class="container" style="margin-top: 5%;">
         <h1 class="title has-text-centered">Persebaran Per Provinsi</h1>
              <bar-chart :chart-data="dataProvinsi" style="height:800px"></bar-chart>
      </div>
      </div>
      <!-- <div class="container" style="height:600px">
     
      </div> -->

    </div>    
</template>

<script>
import BarChart from '../../chart/BarChart.vue'

export default {
  components: { BarChart },

  data: () => ({
    dataCollection: null,
    dataProvinsi:null,
    dataBiro: null,
    dataKota:null,
    //all
    label: null,
    apiData: null,
    //perbiro
    labelBiro: null,
    apiDataBiro: null,
    //provinsi
    labelProvinsi: null,
    apiDataProvinsi: null,
     //kota
    labelKota: null,
    apiDataKota: null,
    biros:[],
    searchBiro:'',
    form:{
      nama_biro:{value:'', type:'', message:''}
    },
    config: {}
  }),
  computed:{
    filterBiro() {
    return this.biros.filter(option => {
        return (
            option.nama_biro
                .toString()
                .toLowerCase()
                .indexOf(this.searchBiro.toLowerCase()) >= 0
        )
    })
  }

  },
  methods: {
    randomcolor()
    {
      var randomColor = Math.floor(Math.random()*16777215).toString(16);

      return "#" + randomColor;
    },

    getBiro()
    {
      var uri = this.$apiUrl + 'biro'

      this.$http.get(uri, this.config).then(response =>
      {
        this.biros = response.data.value
      })
      // .catch(error => {
      //   console.log(error)
      // })
    },
    // async getData(){
    //   this.loaded = false
      
    //   var url =  this.$apiUrl + 'report/all/grafik'
    //   try {
    //     const response = await this.$http.get(url);
        
    //     let results = response.data.value

    //     let labelResult = results.map(a => a.label)
    //     let dataResult = results.map(a => a.data)

    //     this.label = labelResult
    //     this.apiData = dataResult

    //     this.dataCollection = {
    //       labels: this.label,
    //       datasets: [
    //         {
    //           label: 'Jumlah',
    //           backgroundColor: [
    //             'rgba(255, 99, 132, 0.2)',
    //             'rgba(54, 162, 235, 0.2)',
    //             'rgba(255, 206, 86, 0.2)',
    //             'rgba(75, 192, 192, 0.2)',
    //             'rgba(153, 102, 255, 0.2)'
    //           ],
    //           borderColor: [
    //             'rgba(255, 99, 132, 1)',
    //             'rgba(54, 162, 235, 1)',
    //             'rgba(255, 206, 86, 1)',
    //             'rgba(75, 192, 192, 1)',
    //             'rgba(153, 102, 255, 1)'
    //           ],
    //           borderWidth: 1,
    //           data: this.apiData
    //         },
    //       ]
    //     }
        
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },

     async getDataProvinsi(){
      this.loaded = false
      
      var url =  this.$apiUrl + 'report/provinsi'
      try {
        const response = await this.$http.get(url);
        
        let results = response.data.value

        let labelResult = results.map(a => a.label)
        let dataResult = results.map(a => a.data)
        
        let backgroundColor = []
        dataResult.forEach(element => {
          backgroundColor.push(this.randomcolor())
        });

        this.labelProvinsi = labelResult
        this.apiDataProvinsi = dataResult

        this.dataProvinsi = {
          labels: this.labelProvinsi,
          datasets: [
            {
              label: 'Jumlah',
              backgroundColor : backgroundColor,
              // backgroundColor: [
              //   'rgba(255, 99, 132, 0.2)',
              //   'rgba(54, 162, 235, 0.2)',
              //   'rgba(255, 206, 86, 0.2)',
              //   'rgba(75, 192, 192, 0.2)',
              //   'rgba(153, 102, 255, 0.2)'
              // ],
              // borderColor: [
              //   'rgba(255, 99, 132, 1)',
              //   'rgba(54, 162, 235, 1)',
              //   'rgba(255, 206, 86, 1)',
              //   'rgba(75, 192, 192, 1)',
              //   'rgba(153, 102, 255, 1)'
              // ],
              borderWidth: 1,
              data: this.apiDataProvinsi
            },
          ]
        }
        
      } catch (e) {
        console.log(e)
      }
    },

    //  async getDataKota(){
    //   this.loaded = false
      
    //   var url =  this.$apiUrl + 'report/kota'
    //   try {
    //     const response = await this.$http.get(url);
        
    //     let results = response.data.value

    //     let labelResult = results.map(a => a.label)
    //     let dataResult = results.map(a => a.data)

    //     this.labelKota = labelResult
    //     this.apiDataKota = dataResult

    //     this.dataKota = {
    //       labels: this.labelKota,
    //       datasets: [
    //         {
    //           label: 'Jumlah',
    //           backgroundColor: [
    //             'rgba(255, 99, 132, 0.2)',
    //             'rgba(54, 162, 235, 0.2)',
    //             'rgba(255, 206, 86, 0.2)',
    //             'rgba(75, 192, 192, 0.2)',
    //             'rgba(153, 102, 255, 0.2)'
    //           ],
    //           borderColor: [
    //             'rgba(255, 99, 132, 1)',
    //             'rgba(54, 162, 235, 1)',
    //             'rgba(255, 206, 86, 1)',
    //             'rgba(75, 192, 192, 1)',
    //             'rgba(153, 102, 255, 1)'
    //           ],
    //           borderWidth: 1,
    //           data: this.apiDataKota
    //         },
    //       ]
    //     }
        
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },

    // async getDataBiro(id_biro){
    //   this.dataBiro = null
      
    //   var url =  this.$apiUrl + 'report/biro/grafik/' + id_biro
    //   try {
    //     const response = await this.$http.get(url);
        
    //     let results = response.data.value

    //     let labelResult = results.map(a => a.label)
    //     let dataResult = results.map(a => a.data)

    //     this.labelBiro = labelResult
    //     this.apiDataBiro = dataResult

    //     this.dataBiro = {
    //       labels: this.labelBiro,
    //       datasets: [
    //         {
    //           label: 'Jumlah',
    //           backgroundColor: [
    //             'rgba(255, 99, 132, 0.2)',
    //             'rgba(54, 162, 235, 0.2)',
    //             'rgba(255, 206, 86, 0.2)',
    //             'rgba(75, 192, 192, 0.2)',
    //             'rgba(153, 102, 255, 0.2)'
    //           ],
    //           borderColor: [
    //             'rgba(255, 99, 132, 1)',
    //             'rgba(54, 162, 235, 1)',
    //             'rgba(255, 206, 86, 1)',
    //             'rgba(75, 192, 192, 1)',
    //             'rgba(153, 102, 255, 1)'
    //           ],
    //           borderWidth: 1,
    //           data: this.apiDataBiro
    //         },
    //       ]
    //     }
        
    //   } catch (e) {
    //     console.log(e)
    //   }
    // },
  },
  
  mounted () {
    if(this.$session.exists()){
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
        }
      }
    }
    // this.getData()
    this.getDataProvinsi()
    // this.getDataKota()
    // this.getBiro()
  }
}
</script>
